var exports = {
  "kL": "x127c5a35--db6884--container",
  "lZ": "x127c5a35--db6884--phone",
};

module.exports = exports;
